export default __webpack_public_path__ + "static/media/preview-app.1ed546bc.png";